export enum PortalPermissionsEnum {
    AddNewClientUser = 'pwp:client-user:create-new',
    ViewClientUserDetails = 'pwp:client-user:view-details',
    EditClientUserDetails = 'pwp:client-user:edit-details',
    DeleteClientUser = 'pwp:client-user:delete',
    CreateNewDeposits = 'pwp:payments:new-deposits',
    CreateNewWithdrawals = 'pwp:payments:new-withdrawal',
    RequestFundsWithdrawal = 'pwp:payments:request-funds-withdrawal',
    NewInternalTransfer = 'pwp:payments:new-internal-transfer',
    UpdatePaymentDetails = 'pwp:payments:update-payment-details',
    ViewBankAccount = 'pwp:bank-accounts:view',
    AddBankAccount = 'pwp:bank-accounts:add',
    EditBankAccount = 'pwp:bank-accounts:edit',
    CashAccountsCreateNew = 'pwp:cash-accounts:create-new',
    CashAccountsDelete = 'pwp:cash-accounts:delete',
    CashAccountsView = 'pwp:cash-accounts:view',
    CashAccountsEdit = 'pwp:cash-accounts:edit',
    CashAccountsViewReports = 'pwp:cash-accounts:view-reports',
    CashAccountsCreateNewDeposits = 'pwp:cash-accounts:create-new-deposits',
    CashAccountsCreateNewTransfers = 'pwp:cash-accounts:create-new-transfers',
    CashAccountsCreateNewWithdrawals = 'pwp:cash-accounts:create-new-withdrawals',
    TradingAccountsCreateNew = 'pwp:trading-accounts:create-new',
    TradingAccountsDelete = 'pwp:trading-accounts:delete',
    TradingAccountsView = 'pwp:trading-accounts:view',
    TradingAccountsEdit = 'pwp:trading-accounts:edit',
    TradingAccountsViewReports = 'pwp:trading-accounts:view-reports',
    TradingAccountsExecuteTrades = 'pwp:trading-accounts:execute-trades',
    TradingAccountsCreateNewDeposits = 'pwp:trading-accounts:create-new-deposits',
    TradingAccountsCreateNewTransfers = 'pwp:trading-accounts:create-new-transfers',
    TradingAccountsCreateNewWithdrawals = 'pwp:trading-accounts:create-new-withdrawals',
    TradingAccountsExchangeCurrency = 'pwp:trading-accounts:exchange-currency',
    SubscriptionManagementViewAvailableFeeds = 'pwp:subscription-management:view-available-feeds',
    SubscriptionManagementAssignFeedsToUsers = 'pwp:subscription-management:assign-feeds-to-users',
    SubscriptionManagementViewAssignedFeeds = 'pwp:subscription-management:view-assigned-feeds',
    SubscriptionManagementViewRevenue = 'pwp:subscription-management:view-revenue',
    SubscriptionManagementViewSubscriptionPrice = 'pwp:subscription-management:view-subscription-price',
    SubscriptionManagementEditAssignedFeeds = 'pwp:subscription-management:edit-assigned-feeds',
    SubscriptionManagementViewFeedPrice = 'pwp:subscription-management:view-feed-price',
    SubscriptionManagementViewMarkups = 'pwp:subscription-management:view-markups',
    SubscriptionManagementSetMarkups = 'pwp:subscription-management:set-markups',
    SubscriptionManagementViewEventHistory = 'pwp:subscription-management:view-event-history',
    SubscriptionManagementViewMarketDataUsageReports = 'pwp:subscription-management:view-market-data-usage-reports',
    ViewTradingAccountStatementsAndReports = 'pwp:reports-and-statements-management:view-trading-account-reports-and-statements',
    ViewCashAccountStatementsAndReports = 'pwp:reports-and-statements-management:view-cash-account-reports-and-statements',
    ViewGroupStatementsAndReports = 'pwp:reports-and-statements-management:view-group-account-reports-and-statements',
    AssignReportTypeToClientUser = 'pwp:reports-and-statements-management:assign-report-types-to-client-users',
    ViewDocuments = 'pwp:documents:view',
    UploadNewDocuments = 'pwp:documents:upload-new',
    UpdateDocumentDetails = 'pwp:documents:update',
    DownloadOrPreviewDocument = 'pwp:documents:download/preview',
    DeleteDocuments = 'pwp:documents:delete',
    ViewOwnProfile = 'pwp:own-user-profile:view-own-profile',
    ViewMessageCenter = 'pwp:own-user-profile:view-message-center',
    ViewCompanyProfile = 'pwp:company-profile:view',
    EditCompanyProfile = 'pwp:company-profile:edit',
    ViewSupervisedUserDetails = 'pwp:supervision:view-user-details',
    EditSupervisedUserDetails = 'pwp:supervision:edit',
    DeleteSupervisedUser = 'pwp:supervision:delete',
    CashOperationsViewTransactionHistoryAndPendingWithdrawals = 'pwp:cash-operations-transaction-history-and-pending-withdrawals:view',
    ViewAccounts = 'pwp:accounts:view',
    AccountsViewTradingAccount = 'pwp:accounts:view-trading-accounts',
    AccountsViewCashAccount = 'pwp:accounts:view-cash-accounts',
    AccountsEditTradingAccount = 'pwp:accounts:edit-trading-accounts',
    AccountsEditCashAccount = 'pwp:accounts:edit-cash-accounts',
    CurrencyExchangeExchangeCurrency = 'pwp:currency-exchange:exchange-currency',
    CurrencyExchangeViewCurrencyTransactions = 'pwp:currency-exchange:view-currency-transactions',
    FPManageAccounts = 'fund-portal:accounts:manage-accounts',
    FPDocumentsView = 'fund-portal:documents:view',
    FPDocumentsUploadNew = 'fund-portal:documents:upload-new',
    FPDocumentsUpdate = 'fund-portal:documents:update',
    FPDocumentsDownloadPreview = 'fund-portal:documents:download/preview',
    FPDocumentsDelete = 'fund-portal:documents:delete'

}
